import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  "https://porfolio-backend-production-aab2.up.railway.app/api";

const API = axios.create({
  baseURL: API_BASE_URL,
});

// Attach JWT token from localStorage to every request
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("adminToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getProjects = () => API.get("/projects");
export const getProject = (id) => API.get(`/projects/${id}`);
export const getFeaturedProjects = () => API.get("/projects/featured");
export const createProject = (data) => API.post("/projects", data);
export const updateProject = (id, data) => API.put(`/projects/${id}`, data);
export const deleteProject = (id) => API.delete(`/projects/${id}`);

export const loginAdmin = (form) => API.post("/auth/login", form);

export default API;